document.addEventListener('DOMContentLoaded', () => {
  const flag = document.getElementById('variant-preorder-flag');
  if (!flag) return;
  const json = document.querySelector('script[type="application/json"][data-product]');
  if (!json) return;
  const product = JSON.parse(json.textContent || '{}');
  const byId = id => product.variants?.find(v => v.id == id);
  const apply = v => {
    if (!v) return;
    const isPre = (v.inventory_quantity||0)<=0 && v.inventory_policy==='continue';
    flag.classList.toggle('hidden', !isPre);
  };
  document.addEventListener('variant:change', e => { if (e.detail?.variant) apply(e.detail.variant); });
  const currentId = document.querySelector('form[action="/cart/add"] input[name="id"]')?.value;
  if (currentId) apply(byId(currentId));
});